import { render } from "./AanmeldingChat.vue?vue&type=template&id=d6df7fb6&scoped=true"
import script from "./AanmeldingChat.vue?vue&type=script&lang=js"
export * from "./AanmeldingChat.vue?vue&type=script&lang=js"

import "./AanmeldingChat.vue?vue&type=style&index=0&id=d6df7fb6&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6df7fb6"]])

export default __exports__